import React from "react";
import DateTime from "components/presentation/DateTime"
import { arraysEqual, getDateTimeFormat } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { Link } from 'react-router-dom';
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";


export const TableExpanded = React.memo((props) => {
    //get node opponets from props
    const { opponents } = props.data;
    //get node results from props
    const { participant } = props.data;
    let params = useUrlFriendlyToParameters();
    const getURL = useGetURL()
    //Copy object in order to change 
    let paramsURL = { ...params }
    const { mirs_discipline } = useUrlFriendlyToParameters()

    let arrQHeaderMatch = ['HOC', 'HBL', 'FBL', 'VBV', 'VVO', 'VBS', 'WPO', 'RU7']

    let headerLabel = arrQHeaderMatch.includes(mirs_discipline) ? 'HeaderMatch' : 'HeaderGame'
    if (mirs_discipline === 'BDM')
        headerLabel = 'HeaderMatches'
    else if (mirs_discipline === 'BKG')
        headerLabel = 'LabelBattle'
    return (
        <table className="table table-detail">
            <thead>
                <tr>
                    <th className="text-start w-10">{Label({ data: 'HeaderDate', noHtml: true })} </th>
                    <th className="text-start w-10">{Label({ data: 'HeaderTime', noHtml: true })} </th>
                    <th className="text-start w-15"></th>
                    <th className="text-center w-10" >{Label({ data: headerLabel, noHtml: true })}</th>
                    <th className="text-start w-15"></th>
                </tr>
            </thead>
            <tbody>

                {opponents && opponents.sort((a, b) => new Date(a.date) - new Date(b.date)).map((item, key) => {
                    paramsURL["mirs_rsc"] = item?.unit?.code //pasamos a la URL la nueva fecha del JSON 
                    const url = getURL(paramsURL, 'results')
                    const result = item?.unit?.code ? <Link to={url}>{item.result}</Link> : item.result
                    const DiffResult = 'WPO'.includes(mirs_discipline) ? item.result !== undefined ? result : '-' : result

                    const date = getDateTimeFormat('DayName-DayNum-MonthShort');
                    const time = getDateTimeFormat('HourMinute');
                    return (
                        <tr key={'expanded-pool-' + item?.participant?.code + '-' + key}>
                            <td className="text-start"><DateTime datetime={item.date} format={date} /></td>
                            <td className="text-start w-40"><DateTime datetime={item.date} format={time} /></td>
                            <td className="d-flex"><Noc {...participant?.organisation} /><Competitor hidePicture={true} {...participant} /></td>
                            <td className="text-center">{DiffResult}</td>
                            <td className="d-flex"><Noc {...item?.participant?.organisation} /><Competitor hidePicture={true} {...item?.participant} /></td>
                        </tr>
                    )
                })}

            </tbody>
        </table>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza

    return (
        //renderizamos cuando un dato de los visibles cambia

        arraysEqual(prevProps.data, nextProps.data)
    )
});